/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersactiveempty2Inputs */

const en_membersactiveempty2 = /** @type {(inputs: Membersactiveempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No members yet.`)
};

const de_membersactiveempty2 = /** @type {(inputs: Membersactiveempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Mitglieder.`)
};

/**
* | output |
* | --- |
* | "No members yet." |
*
* @param {Membersactiveempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersactiveempty2 = /** @type {((inputs?: Membersactiveempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersactiveempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersactiveempty2(inputs)
	return de_membersactiveempty2(inputs)
});
export { membersactiveempty2 as "membersActiveEmpty" }